import { selectElement } from "../utils/element-handlers.utils";

function TopbarComponent(topbarElement: HTMLElement) {
    const topbarInnerElement = topbarElement.querySelector('.n-topbar-inner') as HTMLElement;
    if (!topbarInnerElement) return;

    initStickyTopbar(topbarElement, topbarInnerElement);

    function initStickyTopbar(flyingTopbarElement: HTMLElement, flyingTopbarInnerElement: HTMLElement) {
        let previousScrollY = 0;
        let previousFlyingTopbarElementTopY = 0;
        let previousIsFlying = false;

        renderStickyTopbar();
        window.addEventListener('scroll', renderStickyTopbar);

        function renderStickyTopbar() {
            const scrollY = window.scrollY;
            const scrollYDelta = scrollY - previousScrollY;
            const flyingTopbarElementHeight = flyingTopbarInnerElement.offsetHeight;
            const isFlying = scrollYDelta > 0
                ? scrollY > flyingTopbarElementHeight
                : previousIsFlying ? scrollY !== 0 : false;
            let flyingTopbarElementTopY = 0;

            if (isFlying) {
                flyingTopbarElementTopY = Math.min(flyingTopbarElementHeight, Math.max(0, previousFlyingTopbarElementTopY - scrollYDelta));
                flyingTopbarElement.classList.add('n-topbar-sticky');
            }
            else {
                flyingTopbarElement.classList.remove('n-topbar-sticky');
            }
            
            flyingTopbarInnerElement.style.top = flyingTopbarElementTopY + 'px';

            previousScrollY = scrollY;
            previousFlyingTopbarElementTopY = flyingTopbarElementTopY;
            previousIsFlying = isFlying;
        }
    }
}

export default function initTopbarComponent() {
    selectElement('.n-topbar', TopbarComponent);
};
